module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div class='dropdown-align-right dropdown-container dropdown-grouped-lines dropdown-theme-button js-add-projects-button'>\n  <div class='" + (['dropdown-toggle', 'button', 'small', 'secondary', 'icon', 'icon-plus', "" + ($e($c((this.parentViewState.get("addProjectInProgress") ? "disabled" : void 0))))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'></div>\n  <ul class='dropdown-selection'>\n    <li>\n      <ul>\n        <li>\n          <span class='js-new-project' data-method='external'>\n            Import from <var>Behance</var>\n          </span>\n        </li>\n        <li>\n          <span class='js-new-project' data-method='scrapeClient'>\n            Import from a client's website\n          </span>\n        </li>\n        <li>\n          <span class='js-new-project' data-method='singleUrl'>\n            Import from a single URL\n          </span>\n        </li>\n        <li>\n          <span class='js-new-project' data-method='pdf'>\n            Import a PDF\n          </span>\n        </li>\n      </ul>\n    </li>\n  </ul>\n</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/projects/templates/add_project_button.js.hamlc
// module id = 1328
// module chunks = 17